<div class="custom-form">
	<fieldset *ngIf="fromLoginContext | async as context">
		<legend>{{ fromAppName ? fromAppName : "From"}} login</legend>
		<div class="login-row">
			<ng-container *ngIf="fromApp">
				<dx-lookup id="fromAppLookupComponent" #fromAppLookup [items]="context.fromApplicationLogins"
					displayExpr="name" [value]="context.data" (onValueChanged)="valueChanged($event, 'from')"
					itemTemplate="listItem" noDataText="There are no existing logins" fieldTemplate="field"
					class="login-lookup">
					<div *dxTemplate="let item of 'field'">
						<div *ngIf="item">
							<div style="float:left">
								<ng-container *ngIf="context.data === item">
									<i class="far fa-check">&nbsp;</i>
								</ng-container>
								<ng-container *ngIf="context.data != item">
									<i class="far fa-minus">&nbsp;</i>
								</ng-container>
							</div>
							{{item.name}}
						</div>
					</div>

					<div *dxTemplate="let item of 'listItem'">
						<div style="float:left">
							<ng-container *ngIf="context.data === item">
								<i class="far fa-check">&nbsp;</i>
							</ng-container>
							<ng-container *ngIf="context.data != item">
								<i class="far fa-minus">&nbsp;</i>
							</ng-container>
						</div>
						{{item.name}}
						<div *ngIf="!linkInfo.fromFixedLogins" style="float:right">
							<i class="far fa-fw fa-trash-alt btn-delete" hint="Delete applicationlogin"
								(click)="deleteApplicationLoginBtn($event, item, 'from')"></i>
						</div>
					</div>
				</dx-lookup>
				<button (click)="toggleFromLogin($event)" class="btn btn-sm add-login-button"
					[ngClass]="{'btn-primary': !fromNewLogin, 'btn-danger': fromNewLogin}">
					<i class="far " [ngClass]="{'fa-plus': !fromNewLogin, 'fa-times': fromNewLogin}"></i>
					New login</button>
			</ng-container>
			<div *ngIf="loadedLogins | async">
				<al-link-edit-application-login #fromApp [formGroup]="formGroup.get('from')" [loginType]="1"
					[applicationId]="linkInfo.fromApplicationId" [fromLinkType]="linkInfo.type" [hidden]="!(showFromLoginForm$ | async)"
					[initLogin]="context.data" [appSide]="'from'" [linkId]="link.id" [appParams]="context.fromApplicationLoginParams"
					(reloadAppLoginDatasource)="reloadSelectedItem($event, false, false, false)">
				</al-link-edit-application-login>
			</div>
		</div>
	</fieldset>
	<fieldset *ngIf="toLoginContext | async as context">
		<legend>{{ toAppName ? toAppName: "To" }} login</legend>
		<div class="login-row">
			<ng-container *ngIf="toApp">
				<dx-lookup #toAppLookup [items]="context.toApplicationLogins" displayExpr="name"
					(onValueChanged)="valueChanged($event, 'to')" [value]="context.data"
					noDataText="There are no existing logins" itemTemplate="listItem" class="login-lookup"
					fieldTemplate="field">
					<div *dxTemplate="let item of 'field'">
						<div *ngIf="item">
							<div style="float:left">
								<ng-container *ngIf="context.data === item">
									<i class="far fa-check">&nbsp;</i>
								</ng-container>
								<ng-container *ngIf="context.data != item">
									<i class="far fa-minus">&nbsp;</i>
								</ng-container>
							</div>
							{{item.name}}
						</div>
					</div>
					<div *dxTemplate="let item of 'listItem'">
						<div style="float:left">
							<ng-container *ngIf="context.data === item">
								<i class="far fa-check">&nbsp;</i>
							</ng-container>
							<ng-container *ngIf="context.data != item">
								<i class="far fa-minus">&nbsp;</i>
							</ng-container>
						</div>
						{{item.name}}
						<div style="float:right">
							<i *ngIf="!linkInfo.toFixedLogins" class="far fa-fw fa-trash-alt btn-delete"
								hint="Delete applicationlogin"
								(click)="deleteApplicationLoginBtn($event, item, 'to')"></i>
						</div>
					</div>
				</dx-lookup>
				<button (click)="toggleToLogin($event)" class="btn btn-sm add-login-button"
					[ngClass]="{'btn-primary': !toNewLogin, 'btn-danger': toNewLogin}">
					<i class="far " [ngClass]="{'fa-plus': !toNewLogin, 'fa-times': toNewLogin}"></i> New login</button>
			</ng-container>
			<div *ngIf="loadedLogins | async">
				<al-link-edit-application-login #toApp [formGroup]="formGroup.get('to')" [loginType]="2"
					[applicationId]="linkInfo.toApplicationId" [fromLinkType]="linkInfo.type" [hidden]="!(showToLoginForm$ | async)"
					[initLogin]="context.data" [appSide]="'to'" [linkId]="link.id" [appParams]="context.toApplicationLoginParams"
					(reloadAppLoginDatasource)="reloadSelectedItem($event, false, false, false)">
				</al-link-edit-application-login>
			</div>
		</div>
	</fieldset>
</div>
<button *ngIf="isAdmin" (click)="openAppLoginManagementModal()" class="btn btn-primary btn-sm">[Admin] Manage app login
	fields</button>
<al-link-edit-auth-generic-modal #editAppFieldModal></al-link-edit-auth-generic-modal>
